import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, PaymentCard } from '@mews-commander/types';
import { SpacedLongDash } from '@mews-commander/ui';
import { createCardLabel } from '@mews-commander/legacy-entities/src/ducks';
import { getPaymentCard } from '../../../../selectors';

interface Props {
    paymentCard: PaymentCard;
}

interface OwnProps {
    paymentCardId: string;
}

const PaymentCardDetail: React.FC<Props> = ({ paymentCard }) =>
    paymentCard ? <>{`${createCardLabel(paymentCard)}`}</> : <>{SpacedLongDash}</>;

export default connect<Props, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        paymentCard: (state: ApplicationState, { paymentCardId }: OwnProps) =>
            getPaymentCard(state, { id: paymentCardId }),
    })
)(PaymentCardDetail);
